import { createFileRoute, redirect } from "@tanstack/react-router";

/** The exercises moved into the library; old links land on its exercises tab. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders
export const Route = createFileRoute("/(private)/exercises/")({
  beforeLoad: () => {
    throw redirect({ to: "/library/exercises" });
  },
});
